<template>
    <checker-detail-row>
        <div slot="left">Billing Frequency</div>
        <div slot="right">
            <template v-if="seasonIntervalData">
                {{ seasonIntervalData.billing.interval_count }} {{ seasonIntervalData.billing.interval }}
            </template>
            <template v-else>
                Rolling Monthly
            </template>
        </div>
    </checker-detail-row>
</template>

<script>
    import CheckerDetailRow from '../CheckerDetailRow';
    import { mapGetters } from 'vuex';

    export default {
        name: 'billing-frequency-row',

        components: { CheckerDetailRow },

        computed: {
            ...mapGetters('booking', [
                'seasonIntervalData',
            ]),
        },
    };
</script>
